// 简单的toast提示工具
const toast = {
  // 创建toast元素的内部函数
  _createToast: (message, type = 'default', duration = 2000) => {
    // 检查是否已存在toast元素，如果有则移除
    const existingToast = document.querySelector('.custom-toast');
    if (existingToast) {
      existingToast.remove();
    }

    // 创建新的toast元素
    const toastElement = document.createElement('div');
    toastElement.className = 'custom-toast';
    toastElement.innerText = message;
    
    // 根据类型设置不同背景色
    let bgColor = 'rgba(0, 0, 0, 0.7)'; // 默认
    if (type === 'success') bgColor = 'rgba(24, 144, 255, 0.9)'; // 成功
    if (type === 'error') bgColor = 'rgba(255, 73, 73, 0.9)'; // 错误
    
    // 设置样式
    Object.assign(toastElement.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: bgColor,
      color: 'white',
      padding: '10px 20px',
      borderRadius: '4px',
      zIndex: '9999',
      fontSize: '14px',
      textAlign: 'center',
      pointerEvents: 'none',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
    });

    // 添加到body
    document.body.appendChild(toastElement);

    // 设置动画效果
    toastElement.style.opacity = '0';
    setTimeout(() => {
      toastElement.style.transition = 'opacity 0.3s ease';
      toastElement.style.opacity = '1';
    }, 10);

    // 设置自动消失
    setTimeout(() => {
      toastElement.style.opacity = '0';
      setTimeout(() => {
        toastElement.remove();
      }, 300);
    }, duration);
    
    return toastElement;
  },
  
  // 导出的方法
  default: (message, duration) => {
    toast._createToast(message, 'default', duration);
  },
  
  success: (message, duration) => {
    toast._createToast(message, 'success', duration);
  },
  
  error: (message, duration) => {
    toast._createToast(message, 'error', duration);
  },
  
  // Vue插件安装方法
  install: (app) => {
    app.config.globalProperties.$toast = toast;
  }
};

export default toast;